/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BulkEnableProceduresDto,
  BulkEnableResultResponse,
  ClinicProcedureListResponse,
  ClinicProcedureResponse,
  ClinicProceduresListParams,
  ClinicProceduresRemove200,
  ClinicProceduresReorder200,
  CreateClinicProcedureDto,
  DefaultConsumableResponse,
  ReorderClinicProceduresDto,
  SetDefaultConsumablesDto,
  UpdateClinicProcedureDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * قیمت‌ها به **ریال** برمی‌گردند؛ تبدیل به تومان کار لایهٔ نمایش است. totalBlockMinutes همان مدتی است که موتور نوبت‌دهی در تقویم رزرو می‌کند (مدت جلسه + زمان آماده‌سازی).
 * @summary فهرست خدمات کلینیک با تعرفه
 */
export const clinicProceduresList = (
    params?: ClinicProceduresListParams,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProcedureListResponse>(
      {url: `/api/v1/clinic-procedures`, method: 'GET',
        params, signal
    },
      );
    }




export const getClinicProceduresListQueryKey = (params?: ClinicProceduresListParams,) => {
    return [
    `/api/v1/clinic-procedures`, ...(params ? [params] : [])
    ] as const;
    }


export const getClinicProceduresListQueryOptions = <TData = Awaited<ReturnType<typeof clinicProceduresList>>, TError = void>(params?: ClinicProceduresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicProceduresListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicProceduresList>>> = ({ signal }) => clinicProceduresList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicProceduresListQueryResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresList>>>
export type ClinicProceduresListQueryError = void


export function useClinicProceduresList<TData = Awaited<ReturnType<typeof clinicProceduresList>>, TError = void>(
 params: undefined |  ClinicProceduresListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresList>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresList<TData = Awaited<ReturnType<typeof clinicProceduresList>>, TError = void>(
 params?: ClinicProceduresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresList>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresList<TData = Awaited<ReturnType<typeof clinicProceduresList>>, TError = void>(
 params?: ClinicProceduresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست خدمات کلینیک با تعرفه
 */

export function useClinicProceduresList<TData = Awaited<ReturnType<typeof clinicProceduresList>>, TError = void>(
 params?: ClinicProceduresListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicProceduresListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * مقادیر خالی از پیش‌فرض‌های کاتالوگ پر می‌شوند: قیمت، مدت، زمان آماده‌سازی و لزوم رضایت‌نامه.
 * @summary افزودن یک خدمت به فهرست خدمات کلینیک
 */
export const clinicProceduresCreate = (
    createClinicProcedureDto: CreateClinicProcedureDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProcedureResponse>(
      {url: `/api/v1/clinic-procedures`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClinicProcedureDto, signal
    },
      );
    }




export const getClinicProceduresCreateMutationKey = () => ['clinicProceduresCreate'] as const;

export const getClinicProceduresCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresCreate>>, TError,ClinicProceduresCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresCreate>>, TError,ClinicProceduresCreateMutationVariables, TContext> => {

const mutationKey = getClinicProceduresCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresCreate>>, ClinicProceduresCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicProceduresCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresCreateMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresCreate>>>
    export type ClinicProceduresCreateMutationBody = CreateClinicProcedureDto
    export type ClinicProceduresCreateMutationError = void
    export type ClinicProceduresCreateMutationVariables = {data: CreateClinicProcedureDto}

    /**
 * @summary افزودن یک خدمت به فهرست خدمات کلینیک
 */
export const useClinicProceduresCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresCreate>>, TError,ClinicProceduresCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresCreate>>,
        TError,
        ClinicProceduresCreateMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresCreateMutationOptions(options), queryClient);
    }
    /**
 * هر مورد را با procedureId یا با key کاتالوگ معرفی کنید. خدماتی که از قبل فعال‌اند به‌طور پیش‌فرض دست‌نخورده می‌مانند تا تعرفه‌های ویرایش‌شده بازنویسی نشوند؛ برای بازنویسی overwriteExisting=true بفرستید. کلیدهای ناشناخته در notFound برمی‌گردند و باعث شکست کل درخواست نمی‌شوند.
 * @summary فعال‌سازی گروهی خدمات (راه‌اندازی کلینیک)
 */
export const clinicProceduresBulkEnable = (
    bulkEnableProceduresDto: BulkEnableProceduresDto,
 signal?: AbortSignal
) => {


      return apiClient<BulkEnableResultResponse>(
      {url: `/api/v1/clinic-procedures/bulk-enable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkEnableProceduresDto, signal
    },
      );
    }




export const getClinicProceduresBulkEnableMutationKey = () => ['clinicProceduresBulkEnable'] as const;

export const getClinicProceduresBulkEnableMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresBulkEnable>>, TError,ClinicProceduresBulkEnableMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresBulkEnable>>, TError,ClinicProceduresBulkEnableMutationVariables, TContext> => {

const mutationKey = getClinicProceduresBulkEnableMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresBulkEnable>>, ClinicProceduresBulkEnableMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicProceduresBulkEnable(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresBulkEnableMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresBulkEnable>>>
    export type ClinicProceduresBulkEnableMutationBody = BulkEnableProceduresDto
    export type ClinicProceduresBulkEnableMutationError = void
    export type ClinicProceduresBulkEnableMutationVariables = {data: BulkEnableProceduresDto}

    /**
 * @summary فعال‌سازی گروهی خدمات (راه‌اندازی کلینیک)
 */
export const useClinicProceduresBulkEnable = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresBulkEnable>>, TError,ClinicProceduresBulkEnableMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresBulkEnable>>,
        TError,
        ClinicProceduresBulkEnableMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresBulkEnableMutationOptions(options), queryClient);
    }
    /**
 * ردیف‌هایی که به این کلینیک تعلق ندارند بی‌صدا نادیده گرفته می‌شوند.
 * @summary تغییر ترتیب نمایش خدمات
 */
export const clinicProceduresReorder = (
    reorderClinicProceduresDto: ReorderClinicProceduresDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProceduresReorder200>(
      {url: `/api/v1/clinic-procedures/reorder`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: reorderClinicProceduresDto, signal
    },
      );
    }




export const getClinicProceduresReorderMutationKey = () => ['clinicProceduresReorder'] as const;

export const getClinicProceduresReorderMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresReorder>>, TError,ClinicProceduresReorderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresReorder>>, TError,ClinicProceduresReorderMutationVariables, TContext> => {

const mutationKey = getClinicProceduresReorderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresReorder>>, ClinicProceduresReorderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  clinicProceduresReorder(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresReorderMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresReorder>>>
    export type ClinicProceduresReorderMutationBody = ReorderClinicProceduresDto
    export type ClinicProceduresReorderMutationError = void
    export type ClinicProceduresReorderMutationVariables = {data: ReorderClinicProceduresDto}

    /**
 * @summary تغییر ترتیب نمایش خدمات
 */
export const useClinicProceduresReorder = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresReorder>>, TError,ClinicProceduresReorderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresReorder>>,
        TError,
        ClinicProceduresReorderMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresReorderMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک ردیف تعرفه
 */
export const clinicProceduresGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProcedureResponse>(
      {url: `/api/v1/clinic-procedures/${id}`, method: 'GET', signal
    },
      );
    }




export const getClinicProceduresGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/clinic-procedures/${id}`
    ] as const;
    }


export const getClinicProceduresGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof clinicProceduresGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicProceduresGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicProceduresGetById>>> = ({ signal }) => clinicProceduresGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicProceduresGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresGetById>>>
export type ClinicProceduresGetByIdQueryError = void


export function useClinicProceduresGetById<TData = Awaited<ReturnType<typeof clinicProceduresGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresGetById>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresGetById<TData = Awaited<ReturnType<typeof clinicProceduresGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresGetById>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresGetById<TData = Awaited<ReturnType<typeof clinicProceduresGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک ردیف تعرفه
 */

export function useClinicProceduresGetById<TData = Awaited<ReturnType<typeof clinicProceduresGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicProceduresGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * تغییر قیمت روی جلسات ثبت‌شده و پکیج‌های فروخته‌شده اثری ندارد: جلسه قیمت خودش را نگه می‌دارد و پکیج در لحظهٔ فروش عکس‌برداری می‌شود.
 * @summary ویرایش تعرفه و تنظیمات یک خدمت
 */
export const clinicProceduresUpdate = (
    id: string,
    updateClinicProcedureDto: UpdateClinicProcedureDto,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProcedureResponse>(
      {url: `/api/v1/clinic-procedures/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClinicProcedureDto, signal
    },
      );
    }




export const getClinicProceduresUpdateMutationKey = () => ['clinicProceduresUpdate'] as const;

export const getClinicProceduresUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresUpdate>>, TError,ClinicProceduresUpdateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresUpdate>>, TError,ClinicProceduresUpdateMutationVariables, TContext> => {

const mutationKey = getClinicProceduresUpdateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresUpdate>>, ClinicProceduresUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  clinicProceduresUpdate(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresUpdate>>>
    export type ClinicProceduresUpdateMutationBody = UpdateClinicProcedureDto
    export type ClinicProceduresUpdateMutationError = void
    export type ClinicProceduresUpdateMutationVariables = {id: string;data: UpdateClinicProcedureDto}

    /**
 * @summary ویرایش تعرفه و تنظیمات یک خدمت
 */
export const useClinicProceduresUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresUpdate>>, TError,ClinicProceduresUpdateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresUpdate>>,
        TError,
        ClinicProceduresUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresUpdateMutationOptions(options), queryClient);
    }
    /**
 * اگر جلسه یا نوبتی به این ردیف وصل باشد، ردیف حذف نمی‌شود بلکه غیرفعال می‌شود تا تاریخچهٔ مالی سالم بماند. پاسخ در deleted می‌گوید کدام اتفاق افتاده است.
 * @summary حذف خدمت از فهرست کلینیک
 */
export const clinicProceduresRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ClinicProceduresRemove200>(
      {url: `/api/v1/clinic-procedures/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getClinicProceduresRemoveMutationKey = () => ['clinicProceduresRemove'] as const;

export const getClinicProceduresRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresRemove>>, TError,ClinicProceduresRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresRemove>>, TError,ClinicProceduresRemoveMutationVariables, TContext> => {

const mutationKey = getClinicProceduresRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresRemove>>, ClinicProceduresRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  clinicProceduresRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresRemove>>>

    export type ClinicProceduresRemoveMutationError = void
    export type ClinicProceduresRemoveMutationVariables = {id: string}

    /**
 * @summary حذف خدمت از فهرست کلینیک
 */
export const useClinicProceduresRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresRemove>>, TError,ClinicProceduresRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresRemove>>,
        TError,
        ClinicProceduresRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresRemoveMutationOptions(options), queryClient);
    }
    /**
 * اگر کلینیک فهرست اختصاصی تعریف کرده باشد همان برمی‌گردد، وگرنه فهرست پیش‌فرض کاتالوگ سراسری. مقدارها به میلی‌واحد است (۱ واحد = ۱۰۰۰).
 * @summary مصرف پیش‌فرض متریال برای این خدمت
 */
export const clinicProceduresListConsumables = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<DefaultConsumableResponse[]>(
      {url: `/api/v1/clinic-procedures/${id}/consumables`, method: 'GET', signal
    },
      );
    }




export const getClinicProceduresListConsumablesQueryKey = (id: string,) => {
    return [
    `/api/v1/clinic-procedures/${id}/consumables`
    ] as const;
    }


export const getClinicProceduresListConsumablesQueryOptions = <TData = Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClinicProceduresListConsumablesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof clinicProceduresListConsumables>>> = ({ signal }) => clinicProceduresListConsumables(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClinicProceduresListConsumablesQueryResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresListConsumables>>>
export type ClinicProceduresListConsumablesQueryError = void


export function useClinicProceduresListConsumables<TData = Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresListConsumables>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresListConsumables>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresListConsumables<TData = Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clinicProceduresListConsumables>>,
          TError,
          Awaited<ReturnType<typeof clinicProceduresListConsumables>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClinicProceduresListConsumables<TData = Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مصرف پیش‌فرض متریال برای این خدمت
 */

export function useClinicProceduresListConsumables<TData = Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clinicProceduresListConsumables>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClinicProceduresListConsumablesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * کل فهرست اختصاصی کلینیک را جایگزین می‌کند. فهرست خالی یعنی بازگشت به پیش‌فرض کاتالوگ سراسری.
 * @summary ثبت مصرف پیش‌فرض متریال برای این خدمت
 */
export const clinicProceduresSetConsumables = (
    id: string,
    setDefaultConsumablesDto: SetDefaultConsumablesDto,
 signal?: AbortSignal
) => {


      return apiClient<DefaultConsumableResponse[]>(
      {url: `/api/v1/clinic-procedures/${id}/consumables`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDefaultConsumablesDto, signal
    },
      );
    }




export const getClinicProceduresSetConsumablesMutationKey = () => ['clinicProceduresSetConsumables'] as const;

export const getClinicProceduresSetConsumablesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresSetConsumables>>, TError,ClinicProceduresSetConsumablesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresSetConsumables>>, TError,ClinicProceduresSetConsumablesMutationVariables, TContext> => {

const mutationKey = getClinicProceduresSetConsumablesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clinicProceduresSetConsumables>>, ClinicProceduresSetConsumablesMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  clinicProceduresSetConsumables(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClinicProceduresSetConsumablesMutationResult = NonNullable<Awaited<ReturnType<typeof clinicProceduresSetConsumables>>>
    export type ClinicProceduresSetConsumablesMutationBody = SetDefaultConsumablesDto
    export type ClinicProceduresSetConsumablesMutationError = void
    export type ClinicProceduresSetConsumablesMutationVariables = {id: string;data: SetDefaultConsumablesDto}

    /**
 * @summary ثبت مصرف پیش‌فرض متریال برای این خدمت
 */
export const useClinicProceduresSetConsumables = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clinicProceduresSetConsumables>>, TError,ClinicProceduresSetConsumablesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clinicProceduresSetConsumables>>,
        TError,
        ClinicProceduresSetConsumablesMutationVariables,
        TContext
      > => {
      return useMutation(getClinicProceduresSetConsumablesMutationOptions(options), queryClient);
    }
